import { useEffect } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

export const useAutofillCurrency = (currencyIds: string[]): void => {
  const { setValue } = useFormContext();
  const currency = useWatch({ name: 'currency' });

  useEffect(() => {
    if (currencyIds.length === 1 && !currency) {
      setValue('currency', currencyIds[0]);
    }
  }, [currencyIds, currency, setValue]);
};
